var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.3333H18.3337",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 3.33333V18.3333H11.875V3.33333C11.875 2.41667 11.5 1.66667 10.375 1.66667H9.625C8.5 1.66667 8.125 2.41667 8.125 3.33333Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.33333V18.3333H5.83333V8.33333C5.83333 7.41667 5.5 6.66667 4.5 6.66667H3.83333C2.83333 6.66667 2.5 7.41667 2.5 8.33333Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 12.5V18.3333H17.5003V12.5C17.5003 11.5833 17.167 10.8333 16.167 10.8333H15.5003C14.5003 10.8333 14.167 11.5833 14.167 12.5Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBar);
export default __webpack_public_path__ + "static/media/vertical-bar.a94455e602150915f1fd408a6783fef1.svg";
export { ForwardRef as ReactComponent };